import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomePage from './components/WelcomePage';
import AppointmentLookup from './components/AppointmentLookup';
import PhotoUpload from './components/PhotoUpload';
import Confirmation from './components/Confirmation';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('welcome');
  const [customerData, setCustomerData] = useState(null);
  const [appointmentData, setAppointmentData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const pageVariants = {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 }
  };

  const handleNavigation = (nextPage, data = null) => {
    if (data) {
      if (data.customer) setCustomerData(data.customer);
      if (data.appointment) setAppointmentData(data.appointment);
    }
    setCurrentPage(nextPage);
    setError('');
  };

  const renderCurrentPage = () => {
    const pageProps = {
      onNavigate: handleNavigation,
      customerData,
      appointmentData,
      setIsLoading,
      setError,
      error
    };

    switch (currentPage) {
      case 'welcome':
        return <WelcomePage {...pageProps} />;
      case 'appointment_lookup':
        return <AppointmentLookup {...pageProps} />;
      case 'photo_upload':
        return <PhotoUpload {...pageProps} />;
      case 'confirmation':
        return <Confirmation {...pageProps} />;
      default:
        return <WelcomePage {...pageProps} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4 py-8 max-w-md">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="bg-[#0C1C35] text-white p-6 text-center">
            <img 
              src="https://chefknifeworks.com/logo.png" 
              alt="Chef KnifeWorks" 
              className="h-12 mx-auto mb-3"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h1 className="text-xl font-bold">Chef KnifeWorks</h1>
            <p className="text-blue-200 text-sm mt-1">Drop-Off Check-In</p>
          </div>

          <div className="relative min-h-[500px]">
            {isLoading && <LoadingSpinner />}
            
            <AnimatePresence mode="wait">
              <motion.div
                key={currentPage}
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 0.3 }}
                className="p-6"
              >
                {renderCurrentPage()}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <div className="text-center mt-4 text-sm text-slate-500">
          Need help? Call (555) 123-4567
        </div>
      </div>
    </div>
  );
}

export default App;